import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  let options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/users-permissions/roles`, options)
    .then((response) => {
      var roles = response.data.roles;
      console.log(roles);
      roles.forEach(function (element, index, object) {
        if (element.id == 1 || element.id == 2) {
          object.splice(index, 1);
        }
      });
      console.log(roles);
      return {
        list: roles,
        // meta: response,
      };
    });
}

function getPermissions() {
  let options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/users-permissions/permissions`, options)
    .then((response) => {
      var permissions = response.data;
      var perm = permissions.permissions;
      var newPerm = {};
      Object.keys(perm).forEach((key) => {
        if (key.startsWith("api::")) {
          newPerm[key] = perm[key];
        } else {
          Object.keys(perm[key]["controllers"]).forEach((element, index) => {
            Object.keys(perm[key]["controllers"][element]).forEach(
              (element2, index2) => {
                perm[key]["controllers"][element][element2].enabled = true;
              }
            );
          });
          console.log(perm[key]);
          newPerm[key] = perm[key];
        }
      });
      permissions = {
        permissions: newPerm,
      };
      return permissions;
    });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/users-permissions/roles/${id}`, options)
    .then((response) => {
      let role = response.data.role;
      delete role.links;
      return role;
    });
}

function add(role) {
  var payload = role;
  /*  const payload = jsona.serialize({
    stuff: role,
    includeNames: null,
  }); */

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/users-permissions/roles`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(role) {
  var payload = role;
  /* const payload = jsona.serialize({
    stuff: role,
    includeNames: [],
  }); */

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .put(`${url}/users-permissions/roles/${role.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/users-permissions/roles/${id}`, options);
}

export default {
  list,
  get,
  getPermissions,
  add,
  update,
  destroy,
};
